<template>
  <div class="py-10">
    <v-container
      fluid
      class="px-10"
    >
      <v-row justify="center"> </v-row>
      <v-row>
        <v-col cols="12">
          <v-alert
            :value="alert_error"
            type="error"
            transition="scale-transition"
          >{{ errorMessage }}</v-alert>
          <v-alert
            :value="alert_ok"
            type="success"
            transition="scale-transition"
          >{{ okMessage }}</v-alert>
        </v-col>
        <v-col cols="12">
          <p>{{!isNew ? "Estimado usuario. El ticket fue generado previamente." : "Estimado usuario el CFDI se generó correctamente."}}</p>
          <p>Utilice los botones para obtener XML y representación gráfica en PDF de su factura</p>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-btn
            color="primary"
            @click="getDoc('XML')"
            width="150"
          >
            <v-icon dark>
              mdi-text-box-outline
            </v-icon>Obtener XML
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          md="3"
        ></v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-btn
            color="primary"
            @click="getDoc('PDF')"
            width="150"
          >
            <v-icon dark>
              mdi-file-pdf-box
            </v-icon>Obtener PDF
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"></v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12"></v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
        ></v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-btn
            color="primary"
            @click="irInicio"
            width="150"
          >
            <v-icon dark>
              mdi-arrow-left-bold
            </v-icon>Ir a Inicio
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { executeAction } from "../scripts/baseService.js";
import helpers from "../scripts/helpers.js";

export default {
  name: "Generador",
  data: () => ({
    dataCfdi: null,
    alert_error: false,
    alert_ok: false,
    errorMessage: "",
    okMessage: "",
    isNew: true,
  }),
  created() {
    this.dataCfdi = this.$store.state.ticket;
    this.isNew = this.$store.state.isNew;
    this.$store.commit("setIssue", false);
  },
  methods: {
    irInicio() {
      this.$store.commit("setTicket", null);
      this.$router.push({
        path: "/",
      });
    },

    async getDoc(tipoDoc) {
      let jsonData = {
        format: tipoDoc,
        ticket: this.dataCfdi.ticket,
        fecha_ticket: this.dataCfdi.fecha_ticket.substring(0, 10),
        total: this.dataCfdi.total,
      };

      await executeAction("POST", "CFDI/Retrieve", jsonData, false).then(
        (response) => {
          if (!response.result) {
            this.alert_error = true;
            this.errorMessage = response.errorMessage;
            setTimeout(() => {
              this.alert_error = false;
              this.errorMessage = "";
            }, 10000);
          } else {
            if (tipoDoc === "XML") {
              helpers.ToXML(response.payload, this.dataCfdi.ticket + ".xml");
            } else {
              helpers.ToPDF(response.payload, this.dataCfdi.ticket + ".pdf");
            }
          }
        }
      );
    },
  },
  computed: {},
};
</script>

<style scoped>
.altura {
  height: 40px;
}
</style>
